import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, viewportOnce } from "../lib/motion";

const PRO_AUDIENCES = [
    "QUANTITY SURVEYORS",
    "CONTRACTORS",
    "PROJECT MANAGERS",
    "ARCHITECTURAL PROFESSIONALS",
    "RESIDENTIAL DEVELOPERS",
    "PROPERTY INVESTORS",
];

const ProSuiteBand = () => (
    <section
        data-testid="pro-suite-band"
        className="relative border-t border-white/10 bg-ink py-20 lg:py-28"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="grid gap-10 lg:grid-cols-12"
            >
                <div className="lg:col-span-7">
                    <div className="flex flex-wrap items-center gap-4">
                        <p className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist">
                            <span className="h-1.5 w-1.5 bg-accent" />
                            BUILDEASE PRO
                        </p>
                        <span className="border border-white/20 px-2 py-0.5 font-mono text-[13px] tracking-[0.22em] text-mist">
                            IN DEVELOPMENT
                        </span>
                    </div>
                    <h2 className="mt-6 max-w-xl font-display text-3xl font-semibold leading-[1.12] text-white md:text-4xl">
                        Construction intelligence for professionals.
                    </h2>
                    <p className="mt-5 max-w-xl text-[16px] leading-relaxed text-mist">
                        BuildEase Pro is being developed to support professional
                        construction and property workflows through clearer cost
                        information, project intelligence and informed
                        decision-making. Early access runs through the pilot
                        network — the existing homeowner platform remains the
                        current release.
                    </p>
                    <div className="mt-8">
                        <Link
                            to="/#contact"
                            data-testid="pro-enquire-link"
                            className="inline-flex items-center gap-2 text-[15px] font-semibold text-accent transition-colors duration-300 hover:text-[#ff7026]"
                        >
                            Enquire About BuildEase Pro
                            <ArrowUpRight className="h-4 w-4" />
                        </Link>
                    </div>
                </div>
                <div className="lg:col-span-5">
                    <div
                        data-testid="pro-audiences"
                        className="flex flex-wrap gap-2.5"
                    >
                        {PRO_AUDIENCES.map((a) => (
                            <span
                                key={a}
                                className="border border-white/15 px-3.5 py-2 font-mono text-[13px] tracking-[0.2em] text-mist"
                            >
                                {a}
                            </span>
                        ))}
                    </div>
                    <p className="mt-6 font-mono text-[13px] leading-relaxed tracking-[0.18em] text-cad">
                        BUILDEASE PRO (V2). PROFESSIONAL PRICING WILL BE
                        ANNOUNCED CLOSER TO LAUNCH.
                    </p>
                    <p className="mt-3 font-mono text-[13px] leading-relaxed tracking-[0.18em] text-cad">
                        LONGER-TERM PROFESSIONAL COLLABORATION, FORECASTING AND
                        DEVELOPMENT-FEASIBILITY TOOLS ARE PLANNED FOR LATER
                        VERSIONS
                    </p>
                </div>
            </motion.div>
        </div>
    </section>
);

export default ProSuiteBand;
